import { navy200 } from 'src/styles/color-theme'

export const theme = {
  colors: {
    borderBg: navy200,
  },
  itemHorizontalSpacing: 16,
  maxWidth: 1000,
}
